// Sticky top bar shared by every desktop page (Aura, Style, Try-On, Profile, …).
// Mirrors the AuraHomeDesktop reference: eyebrow + title on the left,
// credits chip + bell + avatar on the right.
import { useAuth } from "@/contexts/AuthContext";
import { CreditsChip } from "@/components/CreditsChip";
import { NotificationsBell } from "@/components/NotificationsBell";

interface Props {
  eyebrow: string;
  title: string;
  onBuyCredits: () => void;
}

export const StitchDesktopHeader = ({ eyebrow, title, onBuyCredits }: Props) => {
  const { user } = useAuth();
  const meta = (user?.user_metadata ?? {}) as Record<string, unknown>;
  const avatarUrl =
    (typeof meta.avatar_url === "string" && meta.avatar_url) ||
    (typeof meta.picture === "string" && meta.picture) ||
    "";
  const initials = (user?.email ?? "?").split(/\s+|@/)[0].slice(0, 2).toUpperCase();

  return (
    <header className="sticky top-0 z-20 flex items-center justify-between gap-4 border-b border-white/5 bg-background/60 px-8 py-4 backdrop-blur-xl">
      <div className="flex items-center gap-3">
        <span className="font-display text-[11px] font-semibold uppercase tracking-[0.32em] text-primary/80">
          — {eyebrow}
        </span>
        <span className="font-display text-base font-bold text-foreground">
          {title}
        </span>
      </div>
      <div className="flex items-center gap-3">
        <CreditsChip onClick={onBuyCredits} />
        <NotificationsBell />
        <div className="flex h-9 w-9 items-center justify-center overflow-hidden rounded-full border border-primary/40 bg-gradient-to-br from-primary/30 to-accent/20 font-display text-xs font-bold">
          {avatarUrl ? (
            <img src={avatarUrl} alt="" referrerPolicy="no-referrer" className="h-full w-full object-cover" />
          ) : initials}
        </div>
      </div>
    </header>
  );
};
